export const LOGIN_CONSTANTS = {
  SIGN_UP: 'Sign Up',
  LOGIN: 'Log In',
  USERNAME: 'Username',
  PASSWORD: 'Password',
};
